<mat-form-field class="w-100 loren-form-field">
  <mat-label>{{ "operations.choose_assets" | transloco }}</mat-label>

  <mat-chip-grid #chipList>
    @for (asset of assets; track asset) {
      <mat-chip-row (removed)="remove(asset)">
        {{asset}}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>

  <input
    placeholder="{{ 'operations.choose_assets' | transloco }}"
    #assetInput
    [formControl]="assetCtrl"
    [matAutocomplete]="auto"
    [matChipInputFor]="chipList"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    (matChipInputTokenEnd)="add($event)"
    />

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (asset of filteredAssets | async; track asset) {
      <mat-option
        [value]="asset.name"
        >
        <img [src]="asset.image | lorenImage | async" width="25" class="" [alt]="asset.name" />
        {{ asset.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
